// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ResultsOverlay.css */
.results {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px; /* Фиксируем ширину для предсказуемости */
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 15px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Новый стиль заголовка */
.results-header {
  color: var(--tg-theme-text-color);
  font-size: 18px;
  line-height: 1.3;
  margin-bottom: 12px;
  width: 100%;
}

.results-header b, .results-header strong {
  color: var(--tg-theme-button-color);
  font-weight: 600;
}

/* Строка спонсора */
.results-sponsor-line {
  font-size: 16px;
  color: var(--tg-theme-text-color);
  margin-bottom: 8px;
  width: 100%;
  text-align: left;
}

.sponsor-none {
  color: var(--tg-theme-hint-color);
}

/* --- Стили рекламы --- */

.ad-container {
  width: 100%;
  margin-bottom: 15px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 0; /* Убрали паддинг контейнера, он будет внутри контента */
  border: 1px solid rgba(0, 0, 0, 0.08);
  min-height: 50px; /* Минимальная высота чтобы не схлопывался */
}


/* Анимация появления реальной рекламы */
.ad-content {
  width: 100%;
  padding-bottom: 12px; /* Паддинг перенесли сюда */
}

.fade-in {
  animation: fadeIn 0.3s ease-in forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.ad-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.ad-text {
  font-size: 14px;
  color: var(--tg-theme-text-color);
  padding: 8px 12px;
  text-align: left;
  line-height: 1.4;
  white-space: pre-wrap;
}

/* Цвет ссылок как у основных кнопок телеграма */
.ad-text a {
  color: var(--tg-theme-button-color, #2481cc);
  text-decoration: none;
  font-weight: 500;
}

.ad-button {
  /* Неяркий оранжевый цвет */
  background-color: #E68A36;
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  border: none;
  padding: 10px 0; /* Меньше вертикальный паддинг */
  border-radius: 10px;
  cursor: pointer;
  margin-top: 5px;
  width: 90%; /* Расширенная кнопка */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity 0.2s;
}

.ad-button:active {
  opacity: 0.8;
}

/* --- Стили для клавиатуры рекламы --- */

.ad-keyboard {
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 8px; /* Отступ между рядами */
  margin: 5px auto 0 auto; /* Центрируем и добавляем верхний отступ */
}

.ad-keyboard-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 8px; /* Отступ между кнопками в ряду */
}

/* Модифицируем существующий .ad-button для работы внутри flex */
.ad-button {
  /* ... существующие стили ... */
  /* Добавляем/перезаписываем для работы в ряду: */
  margin-top: 0;
  flex: 1 1; /* Кнопки занимают равную ширину в ряду */
  width: auto; /* Сбрасываем фиксированную ширину, если была */
  min-width: 0; /* Для корректной работы text-overflow внутри flex */
}

/* --- Кнопки действий (Дорисовать/Закрыть) --- */

.results-actions-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 10px; /* Отступ между кнопками */
}

.results-button-compact {
  flex: 1 1; /* Кнопки занимают равную ширину */
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  font-size: 15px;
  border: none;
  padding: 10px 5px; /* Уменьшенная высота, как у рекламы */
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/results/ResultsOverlay.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY,EAAE,yCAAyC;EACvD,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,0BAA0B;;AAE1B;EACE,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB,EAAE,wDAAwD;EAC3E,qCAAqC;EACrC,gBAAgB,EAAE,4CAA4C;AAChE;;;AAGA,wCAAwC;AACxC;EACE,WAAW;EACX,oBAAoB,EAAE,2BAA2B;AACnD;;AAEA;EACE,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe,EAAE,gCAAgC;EACjD,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,UAAU,EAAE,uBAAuB;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;;AAEzC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,wBAAwB;EAClC,uBAAuB,EAAE,0CAA0C;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,QAAQ,EAAE,iCAAiC;AAC7C;;AAEA,gEAAgE;AAChE;EACE,+BAA+B;EAC/B,gDAAgD;EAChD,aAAa;EACb,SAAO,EAAE,yCAAyC;EAClD,WAAW,EAAE,+CAA+C;EAC5D,YAAY,EAAE,oDAAoD;AACpE;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,SAAO,EAAE,kCAAkC;EAC3C,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,iBAAiB,EAAE,sCAAsC;EACzD,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* ResultsOverlay.css */\n.results {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 350px; /* Фиксируем ширину для предсказуемости */\n  text-align: center;\n  background-color: var(--tg-theme-bg-color);\n  padding: 15px;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n  z-index: 1200;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Новый стиль заголовка */\n.results-header {\n  color: var(--tg-theme-text-color);\n  font-size: 18px;\n  line-height: 1.3;\n  margin-bottom: 12px;\n  width: 100%;\n}\n\n.results-header b, .results-header strong {\n  color: var(--tg-theme-button-color);\n  font-weight: 600;\n}\n\n/* Строка спонсора */\n.results-sponsor-line {\n  font-size: 16px;\n  color: var(--tg-theme-text-color);\n  margin-bottom: 8px;\n  width: 100%;\n  text-align: left;\n}\n\n.sponsor-none {\n  color: var(--tg-theme-hint-color);\n}\n\n/* --- Стили рекламы --- */\n\n.ad-container {\n  width: 100%;\n  margin-bottom: 15px;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-radius: 10px;\n  overflow: hidden;\n  padding-bottom: 0; /* Убрали паддинг контейнера, он будет внутри контента */\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  min-height: 50px; /* Минимальная высота чтобы не схлопывался */\n}\n\n\n/* Анимация появления реальной рекламы */\n.ad-content {\n  width: 100%;\n  padding-bottom: 12px; /* Паддинг перенесли сюда */\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease-in forwards;\n  opacity: 0;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.ad-image {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n.ad-text {\n  font-size: 14px;\n  color: var(--tg-theme-text-color);\n  padding: 8px 12px;\n  text-align: left;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n/* Цвет ссылок как у основных кнопок телеграма */\n.ad-text a {\n  color: var(--tg-theme-button-color, #2481cc);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.ad-button {\n  /* Неяркий оранжевый цвет */\n  background-color: #E68A36;\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 500;\n  border: none;\n  padding: 10px 0; /* Меньше вертикальный паддинг */\n  border-radius: 10px;\n  cursor: pointer;\n  margin-top: 5px;\n  width: 90%; /* Расширенная кнопка */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: opacity 0.2s;\n}\n\n.ad-button:active {\n  opacity: 0.8;\n}\n\n/* --- Стили для клавиатуры рекламы --- */\n\n.ad-keyboard {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px; /* Отступ между рядами */\n  margin: 5px auto 0 auto; /* Центрируем и добавляем верхний отступ */\n}\n\n.ad-keyboard-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  gap: 8px; /* Отступ между кнопками в ряду */\n}\n\n/* Модифицируем существующий .ad-button для работы внутри flex */\n.ad-button {\n  /* ... существующие стили ... */\n  /* Добавляем/перезаписываем для работы в ряду: */\n  margin-top: 0;\n  flex: 1; /* Кнопки занимают равную ширину в ряду */\n  width: auto; /* Сбрасываем фиксированную ширину, если была */\n  min-width: 0; /* Для корректной работы text-overflow внутри flex */\n}\n\n/* --- Кнопки действий (Дорисовать/Закрыть) --- */\n\n.results-actions-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  gap: 10px; /* Отступ между кнопками */\n}\n\n.results-button-compact {\n  flex: 1; /* Кнопки занимают равную ширину */\n  background-color: var(--tg-theme-button-color);\n  color: var(--tg-theme-button-text-color);\n  font-size: 15px;\n  border: none;\n  padding: 10px 5px; /* Уменьшенная высота, как у рекламы */\n  border-radius: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
